import React from 'react';

const PATHS = {
  grid: (
    <>
      <rect x="3" y="3" width="7" height="7" rx="1.5" />
      <rect x="14" y="3" width="7" height="7" rx="1.5" />
      <rect x="3" y="14" width="7" height="7" rx="1.5" />
      <rect x="14" y="14" width="7" height="7" rx="1.5" />
    </>
  ),
  shield: <path d="M12 2l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6l8-4z" />,
  // One icon per kind of device, so a row says at a glance what it is.
  logout: (
    <>
      <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
      <path d="M16 17l5-5-5-5M21 12H9" />
    </>
  ),
  windows: (
    <>
      <path d="M3 5.5l7.5-1v7H3z" />
      <path d="M12.5 4.2L21 3v8.5h-8.5z" />
      <path d="M3 12.5h7.5v7L3 18.5z" />
      <path d="M12.5 12.5H21V21l-8.5-1.2z" />
    </>
  ),
  macos: (
    <>
      <rect x="3" y="4" width="18" height="12" rx="1.5" />
      <path d="M12 16v4M8 20h8" />
    </>
  ),
  ios: (
    <>
      <rect x="7" y="2.5" width="10" height="19" rx="2.5" />
      <path d="M10.5 5.5h3" />
    </>
  ),
  android: (
    <>
      <path d="M5 17a7 7 0 0114 0z" />
      <path d="M8 7.5L6.5 5M16 7.5L17.5 5" />
      <circle cx="9.5" cy="13.5" r="0.8" />
      <circle cx="14.5" cy="13.5" r="0.8" />
    </>
  ),
  laptop: (
    <>
      <rect x="3" y="4" width="18" height="12" rx="1.5" />
      <path d="M2 20h20" />
    </>
  ),
  teams: (
    <>
      <circle cx="9" cy="8" r="3" />
      <circle cx="17" cy="9" r="2.5" />
      <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" />
      <path d="M14.5 14.2c2.6.4 4.5 2.6 4.5 5.3" />
    </>
  ),
  sharepoint: <path d="M4 7a2 2 0 012-2h4l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2V7z" />,
  mail: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 7l9 6 9-6" />
    </>
  ),
  apps: (
    <>
      <rect x="4" y="4" width="6" height="6" rx="1.2" />
      <rect x="14" y="4" width="6" height="6" rx="1.2" />
      <rect x="4" y="14" width="6" height="6" rx="1.2" />
      <circle cx="17" cy="17" r="3" />
    </>
  ),
  sparkle: <path d="M12 2l1.8 5.5L19 9l-5.2 1.5L12 16l-1.8-5.5L5 9l5.2-1.5L12 2z" />,
  clipboard: (
    <>
      <path d="M9 3h6v4H9z" />
      <rect x="5" y="5" width="14" height="16" rx="2" />
      <path d="M9 12h6M9 16h6" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3.5 2" />
    </>
  ),
  bell: (
    <>
      <path d="M18 8a6 6 0 10-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.7 21a2 2 0 01-3.4 0" />
    </>
  ),
  chevronDown: <path d="M6 9l6 6 6-6" />,
  info: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 8v5M12 16h.01" />
    </>
  ),
  groups: (
    <>
      <circle cx="8" cy="9" r="3" />
      <circle cx="16" cy="9" r="3" />
      <path d="M2 20c0-3 2.7-5.5 6-5.5s6 2.5 6 5.5M12 20c0-3 2.7-5.5 6-5.5s4 2 4 2" />
    </>
  ),
  tag: (
    <>
      <path d="M20.6 12.6L12 21l-9-9L11.6 2.4H20.6z" />
      <circle cx="16" cy="7" r="1.4" />
    </>
  ),
  box: (
    <>
      <rect x="4" y="3" width="16" height="16" rx="2" />
      <path d="M8 21h8M12 17v4" />
    </>
  ),
  refresh: (
    <>
      <path d="M21 12a9 9 0 0 1-15.3 6.4M3 12a9 9 0 0 1 15.3-6.4" />
      <path d="M21 3v6h-6M3 21v-6h6" />
    </>
  ),
  user: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 20c0-4 3.5-7 8-7s8 3 8 7" />
    </>
  ),
  guest: (
    <>
      <circle cx="10" cy="8" r="3.5" />
      <path d="M3 20c0-3.5 3.1-6.3 7-6.3" />
      <circle cx="18" cy="17" r="4" />
      <path d="M18 15.3v3.4M16.3 17h3.4" />
    </>
  ),
  crown: <path d="M4 18h16l1.2-9-4.7 3-4.5-6.5L7.5 12l-4.7-3L4 18z" />,
  key: (
    <>
      <circle cx="8" cy="15" r="4.5" />
      <path d="M11.2 11.8 20 3M16 8l3 3M13.5 10.5l2.5 2.5" />
    </>
  ),
  moon: <path d="M20 14.5A8.5 8.5 0 119.5 4 6.8 6.8 0 0020 14.5z" />,
  layers: (
    <>
      <path d="M12 2 2 7l10 5 10-5-10-5z" />
      <path d="M2 17l10 5 10-5" />
      <path d="M2 12l10 5 10-5" />
    </>
  ),
  sun: (
    <>
      <circle cx="12" cy="12" r="4.2" />
      <path d="M12 2.5v2.4M12 19.1v2.4M4.6 4.6l1.7 1.7M17.7 17.7l1.7 1.7M2.5 12h2.4M19.1 12h2.4M4.6 19.4l1.7-1.7M17.7 6.3l1.7-1.7" />
    </>
  ),
  cloud: <path d="M7 18a4 4 0 010-8 5.5 5.5 0 0110.6-1.7A4 4 0 0117 18H7z" />,
  feedback: <path d="M21 15a2 2 0 01-2 2H8l-5 4V5a2 2 0 012-2h14a2 2 0 012 2z" />,
};

export default function NcIcon({ name, size = 17 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {PATHS[name] || null}
    </svg>
  );
}
